module.exports = __webpack_public_path__ + "static/media/Ayuthaya-01.f2764ada.svg";